import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { ERROR_DATA, getErrorData, handleErrorData } from "@/js/forms.js";
import { hasRole, isAdminNotConsultant } from "@/js/http/auth.js";
import { formRules } from "@/js/form_rules.js";
import { IMPORTER, listTerms, MONTHS } from "@/js/lists.ts";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultInternalConfig = {
  invoiceNumberingPrefix: "",
  creditNoteNumberingPrefix: "",
  invoiceNumberingNbChars: 9,
  isInvoiceNumberingUseAnnualCycle: true,
  invoiceNumberingStartMonth: 1,
  invoicingTopLeftInformations: "CompanyName\nAddress\nIdentification numbers"
};
export default {
  name: "importerDialog",
  components: {
    ErrorModal: ErrorModal
  },
  props: {
    importerId: Number,
    loggedUserData: Object,
    listCountriesRef: Array,
    listStatesRef: Array,
    listChange: Function,
    close: Function
  },
  data: function data() {
    return {
      options: {
        color: "primary",
        width: 900,
        zIndex: 2000
      },
      isShown: true,
      isLoadingData: false,
      saveCancellationToken: null,
      isValidating: false,
      isCountriesExpanded: 0,
      //mean OPENED (index of opened v-expand-content)
      isInternalConfigExpanded: 0,
      //mean OPENED (index of opened v-expand-content)

      form: {
        id: null,
        name: "",
        mailContact: "",
        accountingExternalId: null,
        isDefaultReceiveEmails: false,
        isPreventingPayment: false,
        priority: 0,
        factoringProviderId: null,
        nameLine: "",
        phoneLine: "",
        taxIdLine: "",
        permitLine: "",
        addressLine1: "",
        addressLine2: "",
        partnerLine1: "",
        partnerLine2: "",
        partnerLine3: "",
        isCustomsInvoiceSameAsInvoice: true,
        customsInvoiceLeftTitle: "Imported by",
        customsInvoiceLeftNameLine: null,
        customsInvoiceLeftPhoneLine: null,
        customsInvoiceLeftTaxIdLine: null,
        customsInvoiceLeftPermitLine: null,
        customsInvoiceLeftAddressLine1: null,
        customsInvoiceLeftAddressLine2: null,
        customsInvoiceLeftPartnerLine1: null,
        customsInvoiceLeftPartnerLine2: null,
        customsInvoiceLeftPartnerLine3: null,
        customsInvoiceRightTitle: "Ship to",
        customsInvoiceRightNameLine: null,
        customsInvoiceRightPhoneLine: null,
        customsInvoiceRightTaxIdLine: null,
        customsInvoiceRightPermitLine: null,
        customsInvoiceRightAddressLine1: null,
        customsInvoiceRightAddressLine2: null,
        customsInvoiceRightPartnerLine1: null,
        customsInvoiceRightPartnerLine2: null,
        customsInvoiceRightPartnerLine3: null,
        countriesAvailable: [{
          id: 226,
          statesAvailableId: [],
          customerTypesAvailable: [IMPORTER.customerTypes.HORECA.id, IMPORTER.customerTypes.WHOLESALER.id]
        }],
        isInternalImporter: false,
        internalConfig: _objectSpread({}, defaultInternalConfig),
        valid: false
      },
      listStates: [],
      customerTypesAvailable: Object.values(IMPORTER.customerTypes),
      listFactoringProviders: [],
      listMonths: Object.values(MONTHS),
      managedExceptions: {
        warning: {
          NAME_EMPTY: "Name is required",
          MAIL_CONTACT_INVALID: "Mail address is invalid",
          NAME_LINE_EMPTY: "Name on document is required",
          ADDRESS_LINE1_EMPTY: "Address is required",
          COUNTRIES_AVAILABLE_EMPTY: "One country is required",
          COUNTRY_NOT_AVAILABLE: "A country is not available",
          CUSTOMER_TYPES_AVAILABLE_EMPTY: "One customer type is required for a country",
          STATE_NOT_AVAILABLE: "One state is not available for a country"
        }
      },
      ERROR_DATA: ERROR_DATA,
      listTerms: listTerms,
      formRules: formRules
    };
  },
  computed: {
    isAdding: function isAdding() {
      return +this.form.id <= 0;
    },
    canManageFactoringProviders: function canManageFactoringProviders() {
      return isAdminNotConsultant(this.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_FACTORING);
    },
    getFactoryProviders: function getFactoryProviders() {
      var list = [{
        id: null,
        name: "None"
      }];
      if (!this.canManageFactoringProviders) {
        var _this$form$factoringP;
        if ((_this$form$factoringP = this.form.factoringProvider) !== null && _this$form$factoringP !== void 0 && _this$form$factoringP.id) {
          list.push(this.form.factoringProvider);
        }
      } else {
        list = [].concat(_toConsumableArray(list), _toConsumableArray(this.listFactoringProviders.filter(function (x) {
          return x.isImporter;
        })));
      }
      return list;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.form.id = +_this2.importerId;
            if (_this2.isAdding) {
              _context.next = 4;
              break;
            }
            _context.next = 4;
            return _this2.fetchImporter();
          case 4:
            _context.next = 6;
            return _this2.fetchFactoringProviders();
          case 6:
            _this2.refreshStatesAvailable();
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchImporter: function fetchImporter() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoadingData = true;
              _this = _this3;
              _context2.next = 4;
              return request("/v1/importers/" + +_this3.form.id, "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load importer", true);
                handleErrorData(_this, errorData);
                _this.close();
                throw e;
              });
            case 4:
              response = _context2.sent;
              _this3.mapImporter(response.data.value);
              _this3.isLoadingData = false;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    changeIsInternalImporter: function changeIsInternalImporter() {
      if (this.form.isInternalImporter && !this.form.internalConfig) {
        this.form.internalConfig = _objectSpread({}, defaultInternalConfig);
      }
    },
    fetchFactoringProviders: function fetchFactoringProviders() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this4.canManageFactoringProviders) {
                _context3.next = 7;
                break;
              }
              _this = _this4;
              data = {
                includeDeleted: false,
                isImporter: true
              };
              _context3.next = 5;
              return request("/v1/factoring-providers/all", "post", data, true, "api", null).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load financing options.", true);
                  handleErrorData(_this, errorData);
                }
              });
            case 5:
              response = _context3.sent;
              _this4.listFactoringProviders = response.data.value.items;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    save: function save() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this5$saveCancellati;
        var verb, data, _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.isValidating = true;
              (_this5$saveCancellati = _this5.saveCancellationToken) === null || _this5$saveCancellati === void 0 || _this5$saveCancellati.cancel();
              _this5.saveCancellationToken = axios.CancelToken.source();
              verb = _this5.isAdding ? "post" : "put";
              data = _objectSpread({}, _this5.form);
              delete data.valid;
              _this = _this5;
              _context4.next = 9;
              return request("/v1/importers/", verb, data, true, "api", null, _this.saveCancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to save importer", true);
                  handleErrorData(_this, errorData);
                }
                _this.isValidating = false;
                throw e;
              });
            case 9:
              _this5.isValidating = false;
              _this5.$toasted.show(_this5.isAdding ? "Importer created" : "Importer saved", {
                type: "success"
              });
              _this5.listChange();
              _this5.close();
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    mapImporter: function mapImporter(data) {
      var _data$factoringProvid;
      var countriesAvailableToHandle = data.countriesAvailable;
      delete data.countriesAvailable;
      delete this.form.countriesAvailable;
      this.form = _objectSpread(_objectSpread({}, this.form), data);
      if ((_data$factoringProvid = data.factoringProvider) !== null && _data$factoringProvid !== void 0 && _data$factoringProvid.id) {
        this.form.factoringProviderId = data.factoringProvider.id;
      }
      this.form.countriesAvailable = countriesAvailableToHandle.reduce(function (acc, x) {
        return [].concat(_toConsumableArray(acc), [{
          id: x.country.id_country,
          statesAvailableId: x.statesAvailable.map(function (y) {
            return y.id_state;
          }),
          customerTypesAvailable: x.customerTypesAvailable
        }]);
      }, []);
    },
    changeCountry: function changeCountry() {
      this.form.countriesAvailable[0].statesAvailableId = [];
      this.refreshStatesAvailable();
    },
    refreshStatesAvailable: function refreshStatesAvailable() {
      var _this6 = this;
      this.listStates = _toConsumableArray(this.listStatesRef.filter(function (x) {
        return x.id_country == _this6.form.countriesAvailable[0].id;
      }));
    },
    isAdminNotConsultant: isAdminNotConsultant,
    filterIntegerKey: filterIntegerKey
  },
  watch: {
    "form.mailContact": function formMailContact(newVal, oldVal) {
      if (String.isNullOrEmpty(newVal)) {
        this.form.isDefaultReceiveEmails = false;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    var _this$saveCancellatio;
    (_this$saveCancellatio = this.saveCancellationToken) === null || _this$saveCancellatio === void 0 || _this$saveCancellatio.cancel();
  }
};